import { GetGradientCSS } from "js/editor/ThemeEditor/components/Gradient";

export function getTextGradientBackground(color, styleSet) {
    // const gradient = color?.gradient ??
    //     (color?.stops ? color : null) ??
    //     (color?.type === "gradient" ? color.value : null) ??
    //     (typeof color === "string" ? palette?.getColor?.(color)?.gradient : null) ??
    //     palette?.getGradientValue?.(color);
    //
    // const resolvedGradient = gradient?.value?.stops ? gradient.value : gradient;
    //
    // if (!resolvedGradient?.stops?.length) {
    //     return null;
    // }
    let gradient = color.value;

    const gradientCSS = GetGradientCSS({
        // ...resolvedGradient,
        type: gradient.type ?? "linear",
        stops: gradient.stops.map(stop => ({
            ...stop,
            // color: palette?.getColor?.(stop.color)?.toRgbString?.() ?? stop.color
        }))
    });

    return gradientCSS ? `${gradientCSS} text` : null;
}

export function getTextColorCss(color, styleSet) {
    if (color.type === "gradient") {
        const gradientBackground = getTextGradientBackground(color, styleSet);

        if (gradientBackground) {
            return `
                background: ${gradientBackground};
                -webkit-background-clip: text;
                background-clip: text;
                color: transparent;
                -webkit-text-fill-color: transparent;
            `;
        }
    }

    return `color: ${color.value};`;

    // const colorValue = color?.toRgbString?.() ?? color?.value ?? color;
    // if (colorValue == null || typeof colorValue === "object") {
    //     return "";
    // }
    //
    // return colorValue ? `color: ${colorValue};` : "";
}
